import React from 'react';
import { isMobile } from '@pascal/pascal-core';
import WinPopUp from '../../../components/common/winPopup';
import BetPanel from '../../../components/web/betPanel';
import ResultReport from '../../../components/mobile/resultReport';
import CountDown from '../../../components/common/countDown';
import TotalOdd from '../../../components/common/totalOdd';
import { brandedGameIds } from '../../../enums/brandedPartners';

const GameContentWeb = ({
  t,
  win,
  doBet,
  gameId,
  popUp,
  limits,
  cashOut,
  isDemo,
  demoMode,
  userBets,
  gameScene,
  precision,
  reportList,
  betSections,
  currencyCode,
  notification,
  freeBetsList,
  wageringOdd,
  activeFreeBet,
  plusOrCloseIcon,
  handleInputClick,
  disabledBetButton,
  handleIsShowSection,
  currencySymbolOrCode,
  disabledCashOutButton,
  handleChangeInputValue,
  handleBetSectionsState,
}) => {
  return (
    <div
      className={`fishing-game-wrapper ${popUp ? 'is-popup-show' : ''} ${
        gameScene ? 'hide__game__content' : ''
      } ${+gameId === brandedGameIds['747'] ? 'is-747' : ''}`}
    >
      <CountDown reportList={reportList} />
      <div className='fs-control-panel'>
        {!isMobile() && <TotalOdd precision={precision} reportList={reportList} />}
        <ResultReport precision={precision} reportList={reportList} />
        <BetPanel
          t={t}
          isDemo={isDemo}
          doBet={doBet}
          limits={limits}
          userBets={userBets}
          cashOut={cashOut}
          demoMode={demoMode}
          precision={precision}
          reportList={reportList}
          betSections={betSections}
          currencyCode={currencyCode}
          notification={notification}
          freeBetsList={freeBetsList}
          currencySymbolOrCode={currencySymbolOrCode}
          disabledBetButton={disabledBetButton}
          disabledCashOutButton={disabledCashOutButton}
          handleBetSectionsState={handleBetSectionsState}
          handleIsShowSection={handleIsShowSection}
          handleChangeInputValue={handleChangeInputValue}
          plusOrCloseIcon={plusOrCloseIcon}
          handleInputClick={handleInputClick}
          activeFreeBet={activeFreeBet}
          wageringOdd={wageringOdd}
        />
      </div>
      {win?.winAmount && <WinPopUp win={win} demoMode={demoMode} currencyCode={currencyCode} />}
    </div>
  );
};
export default GameContentWeb;
